import { Center, Spinner } from '@chakra-ui/react'

export const VideoCallRoomLoading: React.FC = () => {
  return (
    <Center h="full" color="white">
      <Spinner />
    </Center>
  )
}
